import Reveal from "./Reveal";
import { ShieldCheck, Users, Target, Globe2 } from "lucide-react";

const WHY_IMG =
  "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBidWlsZGluZyUyMGdsYXNzfGVufDB8fHx8MTc4MzYwNjIxOHww&ixlib=rb-4.1.0&q=85";

const reasons = [
  {
    icon: ShieldCheck,
    title: "Credibility & trust",
    desc: "A near-decade track record with governments, institutions and industry leaders across borders.",
  },
  {
    icon: Users,
    title: "Stakeholder access",
    desc: "We convene policymakers, academia, business and civil society around agendas that matter.",
  },
  {
    icon: Target,
    title: "High-impact delivery",
    desc: "From concept to on-ground execution, every engagement is engineered for measurable outcomes.",
  },
  {
    icon: Globe2,
    title: "Cross-sector reach",
    desc: "Experience spanning travel, tourism, technology, IT, startups, business and public policy.",
  },
];

const WhyChooseUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="relative py-20 sm:py-28 bg-[#0B1B3D] overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src={WHY_IMG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0B1B3D]/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-widest text-[#D91C29] font-semibold">Why Urzu Media</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl font-bold text-white tracking-tight mt-3">
              Services built to earn trust and drive dialogue
            </h2>
            <p className="mt-4 text-slate-300 leading-relaxed">
              We don&apos;t just organise events — we craft communications strategies that foster
              meaningful dialogue, exchange and engagement between the people who shape industries.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 gap-6">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <Reveal key={r.title} delay={i * 0.1}>
                <div
                  data-testid={`why-card-${i}`}
                  className="flex gap-5 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-7 hover:bg-white/10 transition-colors duration-300"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#D91C29] flex items-center justify-center shrink-0">
                    <Icon size={22} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-serif-display text-xl font-bold text-white">{r.title}</h3>
                    <p className="mt-2 text-sm text-slate-300 leading-relaxed">{r.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
